function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m433.155 79.5h-353.619c-31.742 0-57.565 25.824-57.565 57.566v234.866c0 8.284 6.716 15 15 15h438.75c8.284 0 15-6.716 15-15v-234.866c0-31.742-25.825-57.566-57.566-57.566z",
  fill: "#e7f0ef"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m433.155 79.5h-177.155v307.432h219.721c8.284 0 15-6.716 15-15v-234.866c0-31.742-25.825-57.566-57.566-57.566z",
  fill: "#d6dbda"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m497 356.494h-482c-8.284 0-15 6.716-15 15v53.745c0 47.564 38.696 86.261 86.261 86.261h339.479c47.564 0 86.261-38.697 86.261-86.261v-53.745c-.001-8.284-6.717-15-15.001-15z",
  fill: "#0095ff"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 103.776,
  cy: 433.997,
  fill: "#ff0059",
  r: 14.894
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 163.776,
  cy: 433.997,
  fill: "#f7ce00",
  r: 14.894
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m497 356.494h-241v155.006h169.739c47.564 0 86.261-38.697 86.261-86.261v-53.745c0-8.284-6.716-15-15-15z",
  fill: "#006eff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m291.248 448.997h-70.496c-8.284 0-15-6.716-15-15s6.716-15 15-15h70.496c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
  fill: "#006eff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m291.248 448.997c8.284 0 15-6.716 15-15s-6.716-15-15-15h-35.248v30z",
  fill: "#003365"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m350.959 111.647c-8.284 0-181.634 0-189.918 0s-15 6.716-15 15l1 75.894c0 8.284 5.716 27.867 14 27.867h189.918c8.284 0 14-19.583 14-27.867l1-75.894c0-8.284-6.716-15-15-15z",
  fill: "#787780"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m350.959 111.647c-4.142 0-49.551 0-94.959 0v118.76h94.959c8.284 0 14-19.583 14-27.867l1-75.894c0-8.283-6.716-14.999-15-14.999z",
  fill: "#57555c"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m410.573 208.694c-8.284 0-15-6.716-15-15v-100.228c0-8.284 6.716-7.775 15-7.775s15-.509 15 7.775v100.228c0 8.284-6.716 15-15 15z",
  fill: "#ff9f00"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m425.608 70.223-163.817-68.56c-3.705-1.551-7.877-1.551-11.582 0l-163.817 68.56c-5.505 2.304-9.121 7.652-9.208 13.619-.086 5.967 3.373 11.418 8.809 13.881l163.817 74.217c1.967.891 4.079 1.337 6.19 1.337s4.223-.446 6.19-1.337l163.817-74.217c5.436-2.463 8.895-7.914 8.809-13.881-.087-5.967-3.703-11.315-9.208-13.619z",
  fill: "#57555c"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m364.959 202.541h-217.918c-8.95 67.281 43.396 124.959 108.959 124.959s117.909-57.678 108.959-124.959z",
  fill: "#fedbab"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m425.608 70.223-163.817-68.56c-1.853-.775-3.822-1.163-5.791-1.163v172.777c2.111 0 4.223-.446 6.19-1.337l163.817-74.217c5.436-2.463 8.895-7.914 8.809-13.881-.087-5.967-3.703-11.315-9.208-13.619z",
  fill: "#3e4a4f"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m364.959 202.541h-108.959v124.959c65.563 0 117.909-57.678 108.959-124.959z",
  fill: "#fec478"
});

var Svg031Online = function Svg031Online(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg031Online, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/031-online.d7a9fe6f.svg";
export { ForwardRef as ReactComponent };